import styled from 'styled-components'

import { colors } from 'styles/theme'

export const CustomRadioCont = styled.div`
  width: max-content;
  display: flex;
  gap: 10px;

  --form-control-color: ${colors.primary};

  label {
    font-family: var(--font-tomorrow);
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
  }

  input[type='radio'] {
    -webkit-appearance: none;
    appearance: none;
    background-color: var(--form-background);
    margin: 0;
    cursor: pointer;

    font: inherit;
    color: ${colors.primary};
    width: 1.15em;
    height: 1.15em;
    border: 0.14em solid ${colors.primary};
    border-radius: 50%;
    transform: translateY(-0.075em);

    display: grid;
    place-content: center;

    &:not(:checked) {
      border: 0.14em solid ${colors.borderHighlight};
    }
  }

  input[type='radio']::before {
    content: '';
    width: 0.65em;
    height: 0.65em;
    border-radius: 50%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(--form-control-color);
    background-color: ${colors.primary};
  }

  input[type='radio']:checked::before {
    transform: scale(0.9);
  }
`
